import RestService from '../services/rest';
import I18nServices from '../services/i18n';

const getAllByLanguage = async (language) => {
  return RestService.getRest('i18n/getAll', { language: I18nServices.I18nLanguages(language) });
};
const getAllI18ns = async () => {
  return RestService.getAuthenticated('i18n/getGrid');
};
const getI18nNewKey = async () => {
  return RestService.getAuthenticated('i18n/newkey');
};
const deleteI18n = async (key) => {
  return RestService.postAuthenticated('i18n/delete', { key });
};
const updateI18n = async (i18n = {}) => {
  return RestService.postAuthenticated('i18n/update', { ...i18n });
};
const createI18n = async (i18n = {}) => {
  return RestService.postAuthenticated('i18n/create', { ...i18n });
};
const getI18n = async (key) => {
  return RestService.getAuthenticated('i18n/get', { key });
};
const getTranslate = async (text, from, to) => {
  return RestService.getAuthenticated('i18n/translate', { text, from, to });
};

export default {
  getAllByLanguage,
  getI18nNewKey,
  getTranslate,
  getAllI18ns,
  deleteI18n,
  updateI18n,
  createI18n,
  getI18n,
};